import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const PageHeader = ({ eyebrow, title, description, actions, testId }) => (
  <div className="flex items-end justify-between gap-6 mb-7" data-testid={testId}>
    <div>
      {eyebrow ? (
        <div className="text-[10px] uppercase tracking-[0.22em] text-bronze mb-2 font-medium">{eyebrow}</div>
      ) : null}
      <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>
      {description ? <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p> : null}
    </div>
    {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
  </div>
);

export const StatCard = ({ label, value, sub, accent = false, trend, testId }) => (
  <div
    data-testid={testId}
    className={`rounded-xl border ${accent ? "border-[#c5a059]/40 bg-[#fef7ee]" : "border-border bg-card"} p-5 hover-lift`}
  >
    <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground font-medium">{label}</div>
    <div className={`mt-2 font-display font-semibold tracking-tight text-3xl ${accent ? "text-bronze" : "text-slate-900"}`}>{value}</div>
    {sub ? (
      <div className="mt-1 flex items-center gap-1 text-xs text-muted-foreground">
        {trend === "up" && <ArrowUpRight className="w-3 h-3 text-emerald-400" />}
        {trend === "down" && <ArrowDownRight className="w-3 h-3 text-rose-400" />}
        <span>{sub}</span>
      </div>
    ) : null}
  </div>
);

export const Pill = ({ children, tone = "" }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-medium border ${tone || "bg-[#c5a059]/10 text-bronze border-[#c5a059]/30"}`}>
    {children}
  </span>
);

export const EmptyState = ({ title = "Nothing here yet", description, action }) => (
  <div className="text-center py-16 border border-dashed border-border rounded-xl bg-[#fafaf9]">
    <div className="font-display text-lg text-slate-600">{title}</div>
    {description ? <div className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</div> : null}
    {action ? <div className="mt-5">{action}</div> : null}
  </div>
);

export const SectionCard = ({ title, action, children, className = "" }) => (
  <div className={`rounded-xl border border-border bg-card p-5 ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between mb-4">
        <div className="font-display text-sm font-semibold tracking-tight">{title}</div>
        {action}
      </div>
    )}
    {children}
  </div>
);
